module.exports = __webpack_public_path__ + "img/ics_f_info_circle_dark_blue.864342b9.svg";